import $ from 'jquery'
$(document).ready(function() {
	//Prevent hidden embed code from autoplaying
	$('.embed-holder.hidden').each(function() {
		//Replace iframe src attribute with a non-standard one.
		$(this).html(
			$(this)
				.html()
				.replace('src=', 'data-src=')
		)
	})

	const videoModalSource = $('[data-remodal-id=video-modal]')
	const videoModal = videoModalSource.remodal()
	const videoContainer = videoModalSource.find('.video-container')
	let currentEmbedCode = ''

	$(document).on('click', '[data-modal-trigger="video"]', function(e) {
		e.preventDefault()
		currentEmbedCode = $(this)
			.find('.embed-holder')
			.html()

		if (currentEmbedCode) {
			videoModal.open()
		}
	})

	//What happens when the video is openning
	$(document).on('opening', '.video-modal', function() {
		//re-apply the iframe src attribute
		videoContainer.html(currentEmbedCode.replace('data-src=', 'src='))
	})

	$(document).on('closed', '.video-modal', function() {
		videoContainer.html('')
	})
})
